export enum Context {
  checkout,
  linkAccount,
}

export interface CheckOut {
  id: string;
  mobileNumber: string;
  amount: number;
  accountName: string;
  abn: string;
  productCode: string;
  redirectUrl?: string;
  merchantGcAccountId: string;
  buyerGcAccountId: string;
  status: string;
  itemDescriptions: string[];
}

export interface SupplierBuyerAssociation {
  term: number;
  termPeriod: string;
  gcAccountId: string;
}

export interface Account {
  name: string;
  gcAccountId: string;
  availableBalance: number;
  hasBalanceToProcess: boolean;
  abn: string;
}

export interface Guarantor {
  firstName: string;
  middleName: string;
  lastName: string;
  isInitiator: boolean;
}

export interface RepaymentSchedule {
  paymentFrequency: string;
  interestRate: number;
  dueDate: string;
  term: number;
  amount: number;
}

export interface AccountIntent {
  id: string;
  merchantAbn: string;
  merchantAccountId: string;
  merchantAccountName: string;
}
